import { renderVtkContextWindow, SurfaceContext, VRContext } from '@features/analysis/rendering/Panels/Renderers/vtkManagers';
import { debounce } from 'lodash';
import React, { useEffect, useRef } from 'react';
import { ContextRef } from '../../utils/vtkUtilites';

const useResizeObserver = ({
  context,
  vtkContainerRef,
  onResize,
  updateTextBoxPositions,
}: {
  context: React.MutableRefObject<SurfaceContext| VRContext | ContextRef | null>;
  vtkContainerRef: React.RefObject<HTMLDivElement | null>;
  onResize?: (width: number, height: number) => void;
  updateTextBoxPositions?: () => void;
}) => {
  const prevSize = useRef<{ width: number; height: number }>({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const resizeObserver = new ResizeObserver(
      debounce((entries: ResizeObserverEntry[]) => {
        entries.forEach((entry) => {
          const { width, height } = entry.contentRect;
          if (
            prevSize.current.width !== width ||
            prevSize.current.height !== height
          ) {
            prevSize.current = { width, height };

            if (context.current) {
              const currentContext = context.current as any;
              if (currentContext.serverFrontDataVtkDisposed) {
                return;
              }

              const { genericRenderWindow, orientationWidget } = currentContext;
              genericRenderWindow?.resize();

              if (!currentContext.serverFrontDataRenderBlocked) {
                orientationWidget?.modified?.();
              }

              renderVtkContextWindow(currentContext, 'resizeObserver');
            }
            if (onResize) {
              onResize(width, height);
            }
            if (updateTextBoxPositions) {
              requestAnimationFrame(() => {
                updateTextBoxPositions();
              });
            }
          }
        });
      }, 100),
    );

    if (vtkContainerRef.current) {
      resizeObserver.observe(vtkContainerRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [context, onResize, vtkContainerRef]);
};

export default useResizeObserver;
